import { Controller } from "@hotwired/stimulus"

// Refreshes the reCAPTCHA v3 token immediately before form submission so it
// is never stale (tokens expire after 2 minutes).
export default class extends Controller {
  static values = { action: String, siteKey: String }

  initialize() {
    this.boundHandleSubmit = this.handleSubmit.bind(this)
  }

  connect() {
    this.element.addEventListener('submit', this.boundHandleSubmit)
  }

  disconnect() {
    this.element.removeEventListener('submit', this.boundHandleSubmit)
  }

  async handleSubmit(event) {
    if (typeof grecaptcha === 'undefined') return

    event.preventDefault()
    event.stopPropagation()

    try {
      const token = await new Promise((resolve, reject) => {
        grecaptcha.ready(() => {
          grecaptcha.execute(this.siteKeyValue, { action: this.actionValue })
            .then(resolve)
            .catch(reject)
        })
      })

      const input = this.element.querySelector(`[name="g-recaptcha-response-data[${this.actionValue}]"]`)
      if (input) input.value = token
    } catch (_e) {
      // Proceed with existing token if refresh fails
    }

    // Remove listener before re-submitting to avoid infinite loop
    this.element.removeEventListener('submit', this.boundHandleSubmit)
    this.element.requestSubmit()
  }
}
